export const optionSelectedMap = {
  'My integrations': 'my integrations',
  'Build integrations': 'information',
  Docs: 'documentation',
  Tools: 'partners',
  'Partner program': 'partners',
  Resources: 'help',
  'Zap templates': 'templates',
};
